import BloodGlucoseFormContext from "./BloodGlucoseFormContext";
import {
  BloodGlucoseObservation,
  BloodGlucoseObservationDto,
  toBloodGlucoseObservation,
} from "./BloodGlucoseObservation";

type BloodGlucoseObservations = {
  statistics: BloodGlucoseObservationStatistics;
  observations: BloodGlucoseObservation[];
};

export type BloodGlucoseObservationsDto = {
  statistics: BloodGlucoseObservationStatistics;
  observations: BloodGlucoseObservationDto[];
};

export const toBloodGlucoseObservations = (
  dto: BloodGlucoseObservationsDto
): BloodGlucoseObservations => ({
  statistics: dto.statistics,
  observations: dto.observations.map((dto) => toBloodGlucoseObservation(dto)),
});

export type BloodGlucoseObservationStatistics = { [key in BloodGlucoseFormContext]?: Stats };

type Stats = {
  medianBloodGlucoseInMilligramsPerDeciliter: number;
};

export default BloodGlucoseObservations;
